/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetV3TeachersR200ResponseInnerSchoolFromJSON, GetV3TeachersR200ResponseInnerSchoolToJSON, } from './GetV3TeachersR200ResponseInnerSchool';
import { GetV3TeachersR200ResponseInnerPremiumLicensesFromJSON, GetV3TeachersR200ResponseInnerPremiumLicensesToJSON, } from './GetV3TeachersR200ResponseInnerPremiumLicenses';
import { GetSchoolAdminsMeDashboardR200ResponseMostRecentRosterSyncEventSyncedByOneOfContentsFromJSON, GetSchoolAdminsMeDashboardR200ResponseMostRecentRosterSyncEventSyncedByOneOfContentsToJSON, } from './GetSchoolAdminsMeDashboardR200ResponseMostRecentRosterSyncEventSyncedByOneOfContents';
/**
 * @export
 */
export const GetV3TeachersR200ResponseInnerRoleEnum = {
    Teacher: 'teacher',
    InstructionalCoach: 'instructional_coach',
    SpecialEducationTeacher: 'special_education_teacher',
    CurriculumCoordinator: 'curriculum_coordinator',
    DirectorOfCurriculum: 'director_of_curriculum',
    RtiCoordinator: 'rti_coordinator',
    TechCoordinator: 'tech_coordinator',
    DirectorOfTechnology: 'director_of_technology',
    AssistantPrincipal: 'assistant_principal',
    Principal: 'principal',
    AssociateSuperintendent: 'associate_superintendent',
    Superintendent: 'superintendent',
    OtherDistrictLevelAdministrator: 'other_district_level_administrator',
    Parent: 'parent',
    Student: 'student',
    Other: 'other'
};
/**
 * @export
 */
export const GetV3TeachersR200ResponseInnerSourceEnum = {
    Clever: 'clever',
    Csv: 'csv',
    ClassLink: 'class-link',
    ClassLinkRaw: 'class-link-raw',
    Renaissance: 'renaissance'
};
/**
 * Check if a given object implements the GetV3TeachersR200ResponseInner interface.
 */
export function instanceOfGetV3TeachersR200ResponseInner(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('grades' in value) || value['grades'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('school' in value) || value['school'] === undefined)
        return false;
    if (!('students' in value) || value['students'] === undefined)
        return false;
    return true;
}
export function GetV3TeachersR200ResponseInnerFromJSON(json) {
    return GetV3TeachersR200ResponseInnerFromJSONTyped(json, false);
}
export function GetV3TeachersR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'firstName': json['firstName'],
        'grades': json['grades'],
        'id': json['id'],
        'lastName': json['lastName'],
        'premiumLicenses': json['premiumLicenses'] == null ? undefined : GetV3TeachersR200ResponseInnerPremiumLicensesFromJSON(json['premiumLicenses']),
        'role': json['role'] == null ? undefined : json['role'],
        'school': GetV3TeachersR200ResponseInnerSchoolFromJSON(json['school']),
        'source': json['source'] == null ? undefined : json['source'],
        'students': (json['students'].map(GetSchoolAdminsMeDashboardR200ResponseMostRecentRosterSyncEventSyncedByOneOfContentsFromJSON)),
    };
}
export function GetV3TeachersR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'firstName': value['firstName'],
        'grades': value['grades'],
        'id': value['id'],
        'lastName': value['lastName'],
        'premiumLicenses': GetV3TeachersR200ResponseInnerPremiumLicensesToJSON(value['premiumLicenses']),
        'role': value['role'],
        'school': GetV3TeachersR200ResponseInnerSchoolToJSON(value['school']),
        'source': value['source'],
        'students': (value['students'].map(GetSchoolAdminsMeDashboardR200ResponseMostRecentRosterSyncEventSyncedByOneOfContentsToJSON)),
    };
}
